//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { axiosGet } from '../../axios/axios.js'
import ItemsSearchField from '../../components/Field/ItemsSearchField.vue'
import DateField from '../../components/Field/DateField.vue'
import { createFieldConfig, Store } from '../../components/QSelectUtils.js'
import FilesGroup from '../../components/File/FilesGroup.js'
import FilesField from '../../components/File/FilesField.vue'
import CardSeparator from '../../components/Card/CardSeparator.vue'
import { getEmptyAdmittanceRecord, qualificationDocumentTypeOptions } from './EmployeeAdmittanceRecord.js'
import { EventBus } from '../../EventBus/EventBus.js'

export default {
  name: 'EmployeeSkillCard',
  components: {
    ItemsSearchField,
    DateField,
    FilesField,
    CardSeparator
  },
  props: {
    admittance: {
      type: Boolean,
      default: false
    },
    admittanceType: {
      type: String,
      default: null
    },
    noSkill: {
      type: Boolean,
      default: false
    },
    record: {
      type: Object,
      default: function () {
        return null
      }
    },
    records: {
      type: Array,
      required: true
    },
    skillAdmittance: {
      type: Array,
      default: null
    },
    skillRequiredAdmittance: {
      type: Array,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    },
    showEmptyAdmittanceListWarning: {
      type: Boolean,
      default: false
    },
    emptyAdmittanceListWarning: {
      type: String,
      default: ''
    },
    objectInitial: {
      type: Object,
      default: null
    }
  },
  data: function () {
    const self = this
    return {
      isNew: !this.record,
      recordLocal: this.record ? Object.assign({}, this.record) : getEmptyAdmittanceRecord(),
      qualificationTypeFieldConfig: createFieldConfig({ allRecordsFn: this.getQualificationTypes }),
      qualificationPositionFieldConfig: createFieldConfig(new Store({
        fullReadable: false,
        searchable: true,
        searchValueMinLength: 1,
        cached: true,
        proxy: {
          urlBase: '/service/obj/search',
          get urlParams () {
            const params = []
            if (this.searchValue) {
              params.push({ param: 'name', type: 'string', action: 'contains', value: this.searchValue, caseSensitive: false })
            }

            return {
              type: 'employeePosition',
              sort: 'name',
              // add: ['unit', 'article'].join(',')
              params: JSON.stringify(params)
            }
          },
          searchCustom: true
        }
      })),
      qualificationDocumentTypeOptions: qualificationDocumentTypeOptions,
      filesGroup: new FilesGroup({
        key: 'document',
        property: 'document',
        title: 'Документ',
        readonly: this.readonly,
        sourceConfig: {
          get objectId () {
            if (self.admittance) {
              const targetRecord = self.skillAdmittance.find(adm => adm.qualificationTypeKey === self.recordLocal.qualificationTypeKey) ||
                                self.skillRequiredAdmittance.find(adm => adm.qualificationTypeKey === self.recordLocal.qualificationTypeKey)
              return targetRecord.id
            }
            return self.recordLocal.id || null // -1
          },
          uploadURL: '/service/delta/document/upload',
          removeURL: '/service/delta/document/deleteFromObject'
        }
      })
    }
  },
  computed: {
    qualificationTypeValue: {
      get: function () {
        return this.recordLocal && this.recordLocal.qualificationType ? [this.recordLocal.qualificationType] : []
      },
      set: function (value) {
        this.setQualificationType(value && value.length ? value[0] : null)
      }
    },
    qualificationPositionValue: {
      get: function () {
        if (this.recordLocal && this.recordLocal.qualificationPosition) {
          return {
            name: this.recordLocal.qualificationPosition
          }
        }
        return null
      },
      set: function (value) {
        this.$set(this.recordLocal, 'qualificationPosition', value && value.name || null)
      }
    },
    documentName: function () {
      return (this.recordLocal.qualificationType && this.recordLocal.qualificationType.docName) || this.recordLocal.docName || null
    },
    employeeQualificationTypes: function () {
      return new Set(this.records.map(record => record.qualificationTypeKey))
    },
    hasToReturnCardDisable: function () {
      return this.readonly
    },
    isCardReturnedDisable: function () {
      return this.readonly || !this.recordLocal.hasToReturnCard
    }
  },
  created: function () {
    this.recordLocal.document.forEach(document => {
      this.filesGroup.pushFile(document)
    })
  },
  methods: {
    onQualificationPositionCreateNewValue (val, done) {
      done({
        id: null,
        name: val
      })
    },
    onQualificationPositionInputValueStarted (updateInputValue) {
      if (this.recordLocal && this.recordLocal.qualificationPosition) {
        updateInputValue(this.recordLocal.qualificationPosition)
      }
    },
    onSendNotification: function () {
      this.$d_ask({
        callback: async (data, action) => {
          if (action === 'yes') {
            const changedProperties = {}
            let admittancePropertyKey
            if (this.objectInitial.skillAdmittance.find(adm => adm.key === this.record.key)) {
              admittancePropertyKey = 'skillAdmittance'
            } else if (this.objectInitial.skillRequiredAdmittance.find(adm => adm.key === this.record.key)) {
              admittancePropertyKey = 'skillRequiredAdmittance'
            }
            if (admittancePropertyKey) {
              changedProperties[admittancePropertyKey] = this.objectInitial[admittancePropertyKey]
              changedProperties[admittancePropertyKey].find(adm => adm.key === this.record.key).handNotification = true
              EventBus.$emit('save-object-changed-properties', changedProperties)
            }
          }
        },
        header: 'Ручная отправка уведомления',
        warning: `Сотрудник ${this.objectInitial.fio} получит уведомление о необходимости сдачи удостоверения ${this.record.name}. Продолжить?`,
        buttons: {
          yes: 'Да',
          no: 'Нет'
        }
      })
    },
    validate: function () {
      let valid = true
      valid &= this.$refs.qualificationType.validate()
      if (this.admittance) {
        valid &= this.$refs.startValidTime.validate()
        valid &= this.$refs.endValidTime.validate()
      }
      if (this.$refs.level) {
        valid &= this.$refs.level.validate()
      }
      return valid
    },
    validateLevel: function (level) {
      if (level != null && level !== '') {
        if (level < 0) {
          return 'Значение должно быть не меньше 0'
        } else if (level > 10) {
          return 'Значение должно быть не больше 10'
        }
        return true
      }
      return 'Обязательное поле'
    },
    getQualificationTypes: function () {
      const employeeQualificationTypes = this.employeeQualificationTypes
      if (this.admittance) {
        return [...(new Set([...this.records.map(rec => rec.qualificationType)]))]
      } else {
        return axiosGet({
          url: `/service/delta/employee/getQualificationTypes?admittance=${!!this.admittance}&driver=false`,
          onSuccess: (response) => {
            return response.data.result.filter(qt => !employeeQualificationTypes.has(qt.key))
          },
          onFailure: 'Ошибка получения списка доступных объектов'
        })
      }
    },
    setQualificationType: function (qualificationType) {
      this.recordLocal.qualificationType = qualificationType
      this.recordLocal.name = qualificationType ? qualificationType.name : null
      this.recordLocal.qualificationTypeKey = qualificationType ? qualificationType.key : null
      this.recordLocal.isAdmittance = qualificationType ? qualificationType.isAdmittance : false
    },
    onApply: async function () {
      if (!this.validate()) {
        return
      }

      await this.uploadFiles()
        .then(result => {
          if (result) {
            const newDocuments = result.results.map(res => res.value.data.result)
            this.recordLocal.document.push(...newDocuments)
          }
        })

      if (this.isNew) {
        if (this.admittance) {
          const targetRecord = this.skillAdmittance.find(adm => adm.qualificationTypeKey === this.recordLocal.qualificationTypeKey) ||
                                this.skillRequiredAdmittance.find(adm => adm.qualificationTypeKey === this.recordLocal.qualificationTypeKey)
          targetRecord.startValidTime = this.recordLocal.startValidTime
          targetRecord.endValidTime = this.recordLocal.endValidTime
          targetRecord.qualificationPosition = this.recordLocal.qualificationPosition
          targetRecord.docN = this.recordLocal.docN
          targetRecord.document = this.recordLocal.document
          targetRecord.hasToReturnCard = this.recordLocal.hasToReturnCard
          targetRecord.isCardReturned = this.recordLocal.isCardReturned
          targetRecord.dailyNotification = this.recordLocal.dailyNotification
          targetRecord.handNotification = this.recordLocal.handNotification
        } else {
          this.records.push(this.recordLocal)
        }
      } else {
        this.record.level = this.recordLocal.level
        this.record.qualificationPosition = this.recordLocal.qualificationPosition || null
        this.record.docN = this.recordLocal.docN
        this.record.startValidTime = this.recordLocal.startValidTime
        this.record.endValidTime = this.recordLocal.endValidTime
        this.record.hasToReturnCard = this.recordLocal.hasToReturnCard
        this.record.isCardReturned = this.recordLocal.isCardReturned
        this.record.dailyNotification = this.recordLocal.dailyNotification
        this.record.handNotification = this.recordLocal.handNotification
      }
      this.$emit('cancel')
    },
    onCancel: function () {
      this.$emit('cancel')
    },

    uploadFiles: function () {
      return this.filesGroup.uploadFiles({
        notify: true,
        notifyAdditional: true,
        target: this
      })
    },
    onRemoveFile: async function ({ file: fileWrapper, filesGroup }) {
      const recordId = this.recordLocal.id || null // -1
      if (recordId == null) {
        filesGroup.deleteFile(fileWrapper)
      } else {
        await filesGroup.removeFile(fileWrapper)
      }

      const index = this.recordLocal.document.findIndex(document => document.id === fileWrapper.id)
      this.recordLocal.document.splice(index, 1)
    }
  }
}
